module.exports = __webpack_public_path__ + "static/Futura-MediumItalic-ba1e5f4fbe9e4bb402b8f7fe8b00ccaa.otf";